module.exports = __webpack_public_path__ + "static/media/UATRE.4a70536e.jpg";